export { default as ShareFetalSexPage } from "./shareFetalSex";
